import { Button, Form, Input, message } from 'antd'
import type { FormProps } from 'antd'
import React, { useCallback, useState } from 'react'

import { postChangePassword } from '~/services/agent'
import { IAgent } from '~/types/agent'

import { ModalFormContainer } from './style'

const Index: React.FC<{
  data: Partial<IAgent>
}> = (props) => {
  const { data } = props

  const [loading, setLoading] = useState(false)
  const onFinish = useCallback<
    Required<FormProps<{ password: string; oldPassword: string }>>['onFinish']
  >(
    (value) => {
      setLoading(true)
      postChangePassword(data.userId!, value.password, value.oldPassword)
        .then(() => {
          message.success('操作成功')
        })
        .catch((err) => {
          message.error(
            err.response.data || err?.message || '操作失败，请稍后再试',
          )
        })
        .finally(() => {
          setLoading(false)
        })
    },
    [data.userId],
  )

  return (
    <ModalFormContainer>
      <Form
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        style={{ maxWidth: 600 }}
        autoComplete="off"
        initialValues={data}
        onFinish={onFinish}
      >
        <Form.Item
          label="原密码"
          name="oldPassword"
          rules={[{ required: true, message: '请输入原密码' }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item
          label="新密码"
          name="password"
          rules={[{ required: true, message: '请输入新密码' }]}
        >
          <Input.Password />
        </Form.Item>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button loading={loading} type="primary" htmlType="submit">
            提交
          </Button>
        </Form.Item>
      </Form>
    </ModalFormContainer>
  )
}

export default Index
